import React, { useState } from "react";
import Nav from "./Navigation.js";

const LightsOut = () => {
  const initialLightsState = [
    [false, false, false],
    [false, false, false],
    [false, false, false],
  ];

  const [lights, setLights] = useState(initialLightsState);

  const toggleLight = (row, col) => {
    const newLights = [...lights];
    newLights[row][col] = !newLights[row][col];
    if (row > 0) newLights[row - 1][col] = !newLights[row - 1][col];
    if (row < 2) newLights[row + 1][col] = !newLights[row + 1][col];
    if (col > 0) newLights[row][col - 1] = !newLights[row][col - 1];
    if (col < 2) newLights[row][col + 1] = !newLights[row][col + 1];
    setLights(newLights);
  };

  const isGameWon = () => {
    return lights.every((row) => row.every((light) => light));
  };

  const newGame = () => {
    // Reset to the initial state or customize as needed
    setLights(initialLightsState);

    // Randomize a few boxes (for example, randomize 3 boxes)
    for (let i = 0; i < 3; i++) {
      const randomRow = Math.floor(Math.random() * 3);
      const randomCol = Math.floor(Math.random() * 3);
      toggleLight(randomRow, randomCol);
    }
  };

  return (
    <div className="text-center text-white">
      <Nav />
      <h2 className="text-2xl font-bold mb-4 mt-2">Lights Out Practice Tool</h2>
      <div>To use, simply click New game and it will randomize a start point for you to practice</div>
      <button
        className="mb-2 px-4 py-2 bg-blue-500 text-white rounded"
        onClick={newGame}
      >
        New Game
      </button>
      <table className="mx-auto">
        <tbody>
          {lights.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((light, colIndex) => (
                <td
                  key={colIndex}
                  className={`w-16 h-16 400 border border-gray-600 cursor-pointer ${
                    light
                      ? "bg-green-400 border-1 border-black-500"
                      : "bg-gray-200"
                  }`}
                  onClick={() => toggleLight(rowIndex, colIndex)}
                />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {isGameWon() && (
        <p className="mt-4 text-green-500">Congratulations! You won!</p>
      )}
      <div className="mt-2"> A few tips and trips</div>
    </div>
  );
};

export default LightsOut;
